module.exports = __webpack_public_path__ + "img/locations.bead4aaf.png";